import { tableAtoms } from '@/consts/scope';
import { ScopeProvider } from 'jotai-scope';
import { ReactNode } from 'react';

export const TableScopeProvider = ({ children }: { children: ReactNode }) => (
  <ScopeProvider atoms={tableAtoms}>{children}</ScopeProvider>
);
